<template>
    <b-modal id="optionGoodsSearch" :title="title" size="md" @show="fn_search_first" @hidden="fn_init">
        <div class="table_list">
            <ul class="search_filter">
                <li>
                    <p>{{ searchName }}</p>
                    <input type="text" :placeholder="`${searchName}을(를) 입력하세요`" class="form_control" v-model="searchInfo.optionGoodsNm" @keyup.enter="fn_search_first">
                    <button class="btn btn_md btn_outline" @click="fn_search_first">조회</button>
                </li>
            </ul>
            <div class="modal_table" style="max-height:425px; overflow:auto;">
                <table class="list">
                    <colgroup>
                        <col width="40">
                        <col width="50">
                        <col width="90">
                        <col width="*">
                        <col width="100">
                    </colgroup>
                    <thead>
                        <tr>
                            <th></th>
                            <th>No</th>
                            <th>이미지</th>
                            <th>옵션상품명</th>
                            <th>가격</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-if="optionGoodsList.length == 0">
                        <td colspan="5"><span>데이터가 없습니다.</span></td>
                    </tr>
                    <tr v-for="(item, index) in optionGoodsList" :key="index">
                        <td>
                            <div class="form_checkbox">
                                <input type="checkbox" :id="'optCheckbox'+index" name="optCheckbox" v-model="checkBox" :value="item.option_goods_seq" @change="fn_check(item)">
                                <label :for="'optCheckbox'+index"></label>
                            </div>
                        </td>
                        <td><span>{{ (searchInfo.pageInfo.page - 1) * searchInfo.pageInfo.pageSize + index + 1 }}</span></td>
                        <td>
                            <span class="img_area">
                                <img :src="'/file/getImgFile/' + item.option_goods_file_id" alt="">
                            </span>
                        </td>
                        <td><span>{{ item.option_goods_nm }}</span></td>
                        <td><span>{{ fn_comma_won(item.option_goods_price) }}</span></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="fn_movePage" v-show="pagingShow"/>
        </div>
        <template #modal-footer="{ ok }">
            <b-button class="btn btn_md btn_gray" v-show="oneBtn" @click="fn_apply">{{ btnLeft }}</b-button>
            <b-button class="btn btn_md btn_deepblue" @click="fn_init(),ok()">{{ btnRight }}</b-button>
        </template>
    </b-modal>

</template>

<script>
    import axios from 'axios'
    import Pagination from "@/components/AdminPagination.vue"
    import commonUtil from "@/mixin/commonUtil";

    export default {
        name: 'optionGoodsSearch',
        mixins: [commonUtil],
        components: {
            Pagination,
        },
        props: {
            title: String,
            btnLeft: String,
            btnRight: String,
            searchName: String,
            oneBtn: Boolean
        },
        data() {
            return {
                checkBox : [],          // 체크된 옵션상품 seq (페이지 이동해도 유지)
                checkedMap : {},        // seq별 체크된 옵션상품 정보
                optionGoodsList : [],
                pagingShow : false,
                searchInfo : {
                    optionGoodsNm : '',
                    useYn : 'Y',        // 사용중인 옵션상품만 조회
                    pageInfo : {
                        page : 1,
                        pageSize : 5,
                        totPage : 0
                    }
                }
            }
        },
        methods : {
            fn_search(){

                axios
                    .post("/api/admin/promise/searchOptionGoods", this.searchInfo)
                    .then((res) => {
                        this.optionGoodsList = res.data.optionList || [];
                        this.searchInfo.pageInfo.totPage = res.data.totCnt;
                        this.pagingShow = this.searchInfo.pageInfo.totPage > 0;
                    })
                    .catch((err) => console.log(err));

            },
            fn_search_first(){
                this.searchInfo.pageInfo.page = 1;
                this.fn_search();
            },
            fn_movePage(page){
                this.searchInfo.pageInfo.page = page;
                this.fn_search();
            },
            fn_check(item){
                if(this.checkBox.includes(item.option_goods_seq)){
                    this.$set(this.checkedMap, item.option_goods_seq, item);
                }else{
                    this.$delete(this.checkedMap, item.option_goods_seq);
                }
            },
            fn_apply(){

                if(this.checkBox.length == 0){
                    alert("체크된 옵션상품이 없습니다.");
                    return;
                }

                let optionList = this.checkBox.map(seq => this.checkedMap[seq]);

                this.$emit('callback', optionList);

                this.fn_init();
                this.$bvModal.hide('optionGoodsSearch');
            },
            fn_init(){
                this.optionGoodsList = [];
                this.checkBox = [];
                this.checkedMap = {};
                this.pagingShow = false;
                this.searchInfo.optionGoodsNm = '';
                this.searchInfo.pageInfo.page = 1;
                this.searchInfo.pageInfo.totPage = 0;
            }
        }
    }
</script>
